import { render, staticRenderFns } from "./UplimitReason.vue?vue&type=template&id=1a4d98c1"
import script from "./UplimitReason.vue?vue&type=script&lang=js"
export * from "./UplimitReason.vue?vue&type=script&lang=js"
import style0 from "./UplimitReason.vue?vue&type=style&index=0&id=1a4d98c1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports